import urlConstants from '../constants/urlConstants';

// Oude YoungLeaders-links uit het CMS gaan naar de nieuwe jongvolwassenen-site.
const resolveUrl = (url) => {
  if (url && url.toLowerCase().includes(urlConstants.YOUNGLEADERS)) {
    return urlConstants.JONGVOLWASSENEN_SITE;
  }
  return url;
};

export const isExternal = (url) => /^https?:\/\//.test(url);

export default resolveUrl;
